// extracted by mini-css-extract-plugin
export default {"root":"AccountRow_root__biu3N","selected":"AccountRow_selected__L8C7F","title":"AccountRow_title__jKYrc","data":"AccountRow_data__XOxJk","address":"AccountRow_address__sTyI2"};